export const settingsConstants = {
  SETTINGS_SET_REMEMBERME: 'SETTINGS_SET_REMEMBERME',
  SETTINGS_SET_LOCALE: 'SETTINGS_SET_LOCALE'
};
